import { Paperclip } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import "./ImagingSection.css";
import PulmonologySaveButton from "../PulmonologySaveButton/PulmonologySaveButton";

const exams = [
  ["XR", "chestXray", "resultReceived", "sep29", "xray"],
  ["ECG", "ecg", "resultReceived", "sep29", "ecg"],
  ["CT", "chestCt", "requested", "ctScheduled", "ct"],
  ["US", "chestUltrasound", "notRequested", "none", "ultrasound"],
  ["V/Q", "vq", "notRequested", "none", "vq"],
  ["BR", "bronchoscopy", "requested", "pending", "bronchoscopy"],
];
export default function ImagingSection({ records = {}, saveRecord, saving, canSave }) {
  const { t } = useTranslation("pulmonology");
  const [items, setItems] = useState(() => exams.map(([, titleKey]) => ({
    id: titleKey,
    titleKey,
    date: "",
    report: "",
    attachment: "",
  })));

  useEffect(() => {
    const savedRecords = records.imaging || [];
    if (!savedRecords.length) return;
    setItems((current) => current.map((item) => {
      const saved = savedRecords.find((entry) => String(entry.description || "").startsWith(`[${item.id}]`));
      if (!saved) return item;
      return {
        ...item,
        report: String(saved.description).slice(item.id.length + 3),
        date: saved.dateDescription ? String(saved.dateDescription).slice(0, 10) : "",
      };
    }));
  }, [records.imaging]);

  const updateItem = (id, field, value) => {
    setItems((current) => current.map((item) => item.id === id
      ? { ...item, [field]: value }
      : item));
  };

  const persistedFor = (item) => (records.imaging || []).find((record) =>
    String(record.description || "").startsWith(`[${item.id}]`)
  );
  const saveReportRecord = (item) => {
    const persistedRecord = persistedFor(item);
    return saveRecord?.("imaging", {
      description: `[${item.id}] ${item.report}`,
      dateDescription: item.date || undefined,
    }, persistedRecord?.id);
  };

  const saveReport = (event) => {
    if (event.key !== "Enter" || event.shiftKey) return;
    event.preventDefault();
  };

  return (
    <section className="pulmo-imaging">
      <h3 className="pulmo-imaging__title">{t("imaging.title")}</h3>
      <div className="pulmo-imaging__list">
        {items.map((item) => (
          <article className="pulmo-imaging-card" key={item.id}>
            <div className="pulmo-imaging-card__header">
              <strong>{t(`imaging.cards.${item.titleKey}`)}</strong>
              <div className="pulmo-imaging-card__actions">
                <label className="pulmo-imaging-card__date"><span>{t("imaging.date")}:</span><input type="date" value={item.date} aria-label={t("imaging.dateAria", { name: t(`imaging.cards.${item.titleKey}`) })} onChange={(event) => updateItem(item.id, "date", event.target.value)} onKeyDown={saveReport} /></label>
                <label className="pulmo-imaging-card__attach"><span aria-hidden="true">↑</span> {t("common.attachFile")}<input type="file" accept=".pdf,image/*" aria-label={t("imaging.attachAria", { name: t(`imaging.cards.${item.titleKey}`) })} onChange={(event) => updateItem(item.id, "attachment", event.target.files?.[0]?.name || "")} /></label>
              </div>
            </div>
            <textarea className="pulmo-imaging-card__report" value={item.report} aria-label={t("imaging.reportAria", { name: t(`imaging.cards.${item.titleKey}`) })} placeholder={t("imaging.reportPlaceholder")} onChange={(event) => updateItem(item.id, "report", event.target.value)} onKeyDown={saveReport} />
            {item.attachment && <div className="pulmo-imaging-card__file" title={item.attachment}><Paperclip size={11} /><span>{item.attachment}</span></div>}
            <div className="pulmo-actions">
              <PulmonologySaveButton onClick={() => saveReportRecord(item)} saving={saving} disabled={!canSave} />
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
